module.exports = __webpack_public_path__ + "static/img/space4.965108d7.png";